import React from "react";

function HMC5883L() {
  return (
    <div>

      <h2>HMC5883L Magnetometer</h2>

    <h2>Triple Axis Magnetometer HMC5883L Interfacing with Raspberry Pi</h2>

<img
  src="https://www.electronicwings.com/storage/PlatformSection/TopicContent/330/icon/Triple%20Axis%20Magnetometer%20HMC5883L%20Interfacing%20with%20Raspberry%20Pi.jpg"
  alt="HMC5883L with Raspberry Pi"
  style={{
    width: "500px",
    margin: "20px 0",
    borderRadius: "10px"
  }}
/>

<h3>Overview of Magnetometer HMC5883L</h3>

<img
  src="https://www.electronicwings.com/storage/PlatformSection/TopicContent/330/description/HMC5883L.jpg"
  alt="HMC5883L Sensor"
  style={{
    width: "400px",
    margin: "20px 0",
    borderRadius: "10px"
  }}
/>

<h3>Magnetometer HMC5883L Module</h3>

<ul>
  <li>
    Magnetometer HMC5883L is used for measuring the direction and magnitude 
    of the Earth’s magnetic field. It is used for low-cost compassing and magnetometry.
  </li>
  <li>
    It measures the Earth’s magnetic field along the X, Y, and Z axes from 
    milli-gauss to 8 gauss.
  </li>
  <li>
    It can be used to find the heading direction of the device.
  </li>
  <li>
    It uses the I2C protocol for communication with the microcontroller.
  </li>
</ul>

<p>
  For more information about the HMC5883L and how to use it, refer to the 
  <strong>HMC5883L Magnetometer Module</strong> in the sensors and modules section.
</p>

<p>
  To interface the HMC5883L magnetometer module with Raspberry Pi, ensure that 
  the I2C protocol is enabled. Before interfacing, proper I2C configuration 
  should be done on the Raspberry Pi.
</p>

<h2>Connection Diagram of HMC5883L Magnetometer with Raspberry Pi</h2>

<img
  src="https://www.electronicwings.com/storage/PlatformSection/TopicContent/330/description/hmc5883_interface_with_Raspberry%20Pi.png"
  alt="HMC5883L with Raspberry Pi"
  style={{
    width: "500px",
    margin: "20px 0",
    borderRadius: "10px"
  }}
/>

<h4>HMC5883L Magnetometer Interfacing with Raspberry Pi 3</h4>

<img
  src="https://www.electronicwings.com/storage/PlatformSection/TopicContent/330/description/Connection%20for%20Triple%20Axis%20Magnetometer%20HMC5883L%20Interfacing%20with%20Raspberry%20Pi.jpg"
  alt="HMC5883L with Raspberry Pi"
  style={{
    width: "500px",
    margin: "20px 0",
    borderRadius: "10px"
  }}
/>

<h3>Get Heading Angle using HMC5883L with Raspberry Pi</h3>

<p>
  By reading the magnetic field strength along the X, Y, and Z axes from the 
  HMC5883L magnetometer, we can calculate the heading angle and display it 
  on the terminal.
</p>

<p>
  The HMC5883L communicates using the I2C protocol and can be interfaced 
  with Raspberry Pi using Python.
</p>

<p>
  To understand the I2C functions in Python on Raspberry Pi, refer to 
  <strong>Python-based I2C functions</strong>.
</p>

<h3>Programming Steps</h3>

<ul>
  <li>
    Set Configuration Register A for an average of 8 samples with a default 
    data output rate of 15 Hz.
  </li>
  <li>
    Set gain using Configuration Register B (e.g., value 0xA0 or as required).
  </li>
  <li>
    Select continuous measurement mode by setting Mode Register to 0x00.
  </li>
  <li>
    After initialization, read raw values from X, Y, and Z-axis registers.
  </li>
</ul>

<h3>Heading Calculation</h3>

<p>
  The heading angle can be calculated using the formula:
</p>

<p>
  <strong> Magnetic Heading = atan2(Y/X)(Radian)</strong>
</p>

<p>
  The result is then converted into degrees.
</p>


<h3>HMC5883L Python Program for Raspberry Pi</h3>

<div
  style={{
    backgroundColor: "#f4f4f4",
    padding: "15px",
    borderRadius: "10px",
    maxHeight: "400px",
    overflowY: "scroll",
    border: "1px solid #ccc",
  }}
>
  <pre style={{ margin: 0 }}>
{`'''
Find Heading by using HMC5883L interface with Raspberry Pi using Python
http://www.electronicwings.com
'''

import smbus
from time import sleep
import math

#some MPU6050 Registers and their Address
Register_A     = 0
Register_B     = 0x01
Register_mode  = 0x02

X_axis_H    = 0x03
Z_axis_H    = 0x05
Y_axis_H    = 0x07
declination = -0.00669
pi          = 3.14159265359

def Magnetometer_Init():
    bus.write_byte_data(Device_Address, Register_A, 0x70)
    bus.write_byte_data(Device_Address, Register_B, 0xa0)
    bus.write_byte_data(Device_Address, Register_mode, 0)

def read_raw_data(addr):
    high = bus.read_byte_data(Device_Address, addr)
    low = bus.read_byte_data(Device_Address, addr+1)

    value = ((high << 8) | low)

    if(value > 32768):
        value = value - 65536
    return value

bus = smbus.SMBus(1)
Device_Address = 0x1e

Magnetometer_Init()

print (" Reading Heading Angle")

while True:
    x = read_raw_data(X_axis_H)
    z = read_raw_data(Z_axis_H)
    y = read_raw_data(Y_axis_H)

    heading = math.atan2(y, x) + declination

    if(heading > 2*pi):
        heading = heading - 2*pi

    if(heading < 0):
        heading = heading + 2*pi

    heading_angle = int(heading * 180/pi)

    print ("Heading Angle = %d°" %heading_angle)
    sleep(1)
`}
  </pre>
</div>

<h3>Connection Diagram of HMC5883L with Raspberry Pi</h3>

<img
  src="https://www.electronicwings.com/storage/PlatformSection/TopicContent/330/description/Triple%20Axis%20Magnetometer%20HMC5883L%20Interfacing%20with%20Raspberry%20Pi%20(2).jpg"
  alt="HMC5883L Connection Diagram"
  style={{
    width: "600px",
    margin: "20px 0",
    borderRadius: "10px",
    display: "block"
  }}
/>

    </div>
  );
}

export default HMC5883L;